/**
 * Created by laszlo.czondor on 2017. 11. 14.
 */
import VueTypeahead from 'vue-typeahead'

const QUERY_HASH = '#query=';

export default {
	extends: VueTypeahead, // vue@1.0.22+
	data() {
		return {
			isOpen: false,
			limit: 5,
			minChars: 3,
			// Highlight the first item in the list
			selectFirst: true,
			queryParamName: 'query',
			query: ''
		}
	},
	props: {
		searchUrl: {
			type: String,
			required: true
		},
		autoSuggestItems: {
			type: Array,
			required: false
		}
	},
	methods: {
		toggleResults(item, isOpen) {
			let isItemString = typeof item === 'string';
			if (isItemString) {
				this.query = item;
				this.search(this.query);
			}
			this.isOpen = isOpen;
		},
		// The callback function which is triggered when the user hits on an item
		onHit($event) {
			if (this.current !== -1) {
				this.query = this.autoSuggestItems[this.current];
				this.isOpen = false;
			}

			if ($event.type === 'keydown' && $event.key === 'Enter') {
				this.search(this.query);
			}
		},

		search(query) {
			if(this.isOnSearchPage) {
				this.$emit('on-search', query);
			} else {
				window.location.href = this.searchUrl + QUERY_HASH + query;
			}
		},

		// The callback function which is triggered when the response data are received
		prepareResponseData(data) {
			this.isOpen = true;
			return data.suggestions;
		},
		update() {
			this.$emit('on-auto-suggest', this.query);
		}
	},
	computed: {
		isOnSearchPage() {
			return window.location.pathname === this.searchUrl;
		}
	},
	mounted() {
		if(window.location.hash && new RegExp(QUERY_HASH).test(window.location.hash)) {
			let query = decodeURI(window.location.hash.split('=')[1]);
			this.query = query;
			this.$emit('on-search', query);
		}
	}
}



// WEBPACK FOOTER //
// ../source/common/search-box/search-box.js